var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fill-height":"","fluid":"","grid-list-xl":""}},[(_vm.loading)?_c('div',[_vm._v("Carregando membros...")]):_vm._e(),(!_vm.loading)?_c('cpn-customer-list',{attrs:{"users":_vm.users,"error":_vm.error}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }